"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_FOOTER_Z_INDEX = void 0;
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const Footnotes_1 = __importDefault(require("../Footnotes"));
const types_1 = require("../Footnotes/types");
const Sources_1 = __importDefault(require("../Sources"));
const types_2 = require("../Sources/types");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const FOOTER_BACKGROUND_COLOR = '#FFFFFF';
exports.DEFAULT_FOOTER_Z_INDEX = 10;
const Footer = _ref => {
  let {
    sources,
    summary,
    footnotes,
    fontSize = 13
  } = _ref;
  const lineHeight = 1.5;
  const marginBottom = 0.5;
  const hasSources = Boolean(true);
  const hasFootnotes = Boolean(footnotes && footnotes.length);
  const footerHeight = (hasSources + hasFootnotes) * fontSize * (lineHeight + marginBottom);
  return react_1.default.createElement("div", {
    className: styles_module_css_1.default.footer,
    style: {
      minHeight: footerHeight,
      boxSizing: 'content-box',
      backgroundColor: FOOTER_BACKGROUND_COLOR,
      zIndex: exports.DEFAULT_FOOTER_Z_INDEX
    }
  }, react_1.default.createElement(Sources_1.default, {
    sources: sources,
    summary: summary,
    style: {
      fontSize,
      lineHeight,
      backgroundColor: FOOTER_BACKGROUND_COLOR
    }
  }), react_1.default.createElement(Footnotes_1.default, {
    footnotes: footnotes,
    style: {
      fontSize,
      lineHeight,
      marginBottom: `${marginBottom}em`,
      backgroundColor: FOOTER_BACKGROUND_COLOR
    }
  }));
};
Footer.propTypes = {
  /**
   * Array of source sets, each with an agencyname and sources with names and urls.
   */
  sources: (0, prop_types_1.arrayOf)(types_2.sourcesType).isRequired,
  /**
   * Summary to be shown when sources are collapsed.
   */
  summary: prop_types_1.string,
  /**
   * Array of footnotes, each with a categorizing name and footnote data.
   */
  footnotes: (0, prop_types_1.arrayOf)(types_1.customFootnoteType).isRequired,
  /**
   * fontSize for all footer text
   */
  fontSize: prop_types_1.number
};
exports.default = Footer;